<script setup lang="ts">
import AfiniusLogo from '@afinius/theme/logos/afinius/gray.svg?component';
import CityviewLogo from '@afinius/theme/logos/cityview/gray.svg?component';
import NodrLogo from '@afinius/theme/logos/nodr/gray.svg?component';
import Cluster from '@afinius/ui-framework/Cluster/Cluster.vue';
import Spinner from '@afinius/ui-framework/Spinner/Spinner.vue';
import Stack from '@afinius/ui-framework/Stack/Stack.vue';
import Typography from '@afinius/ui-framework/Typography/Typography.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const logo = computed(() => {
  switch (import.meta.env.VITE_API_APPLICATION_KEY) {
    case 'nodr':
      return NodrLogo;
    case 'cityview':
      return CityviewLogo;
    default:
      return AfiniusLogo;
  }
});
</script>

<template>
  <Cluster class="splash" justifyContent="center">
    <Stack height="100dvh" justifyContent="space-between" class="splash-content">
      <div class="splash-spacer" />

      <Stack alignItems="center" :gap="1.5">
        <Spinner size="lg" />
        <Typography size="lg"> {{ t('loading') }} </Typography>
      </Stack>

      <component :is="logo" class="splash-logo" />
    </Stack>
  </Cluster>
</template>

<style lang="scss" scoped>
@use './Splash.scss';
</style>
